<div class="dialog-header">
    <div mat-dialog-title>{{ 'deliveryDefenseScoreInfo.title' | translate }}</div>
    <button class="close-icon" mat-dialog-close mat-icon-button tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="dialog-content">
    <div class="gauge">
        <div class="gauge-labels">
            <span class="gauge-label low">{{ 'confidenceGauge.confidence.low' | translate }}</span>
            <span class="gauge-label high">{{ 'confidenceGauge.confidence.high' | translate }}</span>
        </div>
        <div class="gauge-wrapper"></div>
        <div class="gauge-values">
            <span class="gauge-value low">100</span>
            <span class="gauge-value high">1000</span>
        </div>
    </div>
    <div class="scores">
        <div *ngFor="let score of scores; let i = index" class="score">
            <div class="score-range">{{ score.range }}</div>
            <div class="score-message">
                <span *ngIf="i !== (scores.length - 1)"
                      [innerHTML]="'deliveryDefenseScoreInfo.riskMessage' | translate: {
                    range: score.range,
                    maxRange: maxRange,
                    multiplier: score.riskMultiplier
                }" class="no-risk"></span>
                <span *ngIf="i === (scores.length - 1)"
                      [innerHTML]="'deliveryDefenseScoreInfo.noRiskMessage' | translate" class="no-risk"></span>
            </div>
        </div>
    </div>
</div>
